import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';

import MainLayout from '../components/Layout/MainLayout';
import styles from '../assets/styles/ProjectQuota.module.scss';

const CompleteAddProject: React.FC = () => {
  const location = useLocation();
  const additionalCount = (location.state as { additionalCount?: number } | null)?.additionalCount;
  if (typeof additionalCount !== 'number') return <Navigate to="/request-add-project" replace />;

  return (
    <MainLayout title="プロジェクト追加申請完了">
      <main className={styles.page}>
        <section className={styles.card}>
          <h1 className={styles.title}>プロジェクト追加申請が完了しました</h1>
          <p>{additionalCount}PJ分の追加枠を反映しました。</p>
          <Link className={styles.link} to="/board">ボード画面に戻る</Link>
        </section>
      </main>
    </MainLayout>
  );
};

export default CompleteAddProject;
